(function () {
  window.abrwl = window.abrwl || {};
  window.abrwl.strings = window.abrwl.strings || {};
  // window.abrwl.apiEndpoint = '/apps/wishlist'
  // window.abrwl.pageHandle = 'wishlist';
  Object.assign(window.abrwl.strings, {
    loadMoreButton: "Load more",
  });
})();
